import './downloadapp.css'
import androidapp from '../../android/tehranmu.apk'
import iconadnroid from '../../icon/android.png'
import iconclouse from '../../image/close.png'
import { useState } from 'react'
export default function Downloadapp(props) {
    function clousedownload(){
        props.setClose(true)
    }
    return (
        <div className="downloadbox" style={{display: props.close ? 'none' : 'flex'}}>
            <img className='clousedownload' onClick={clousedownload} src={iconclouse} alt='close'></img>
            <p>{props.language === 'en' ? 'Tehranmu application' : 'اپلیکیشن تهران مو'}</p>
            <div>
            <a href={androidapp} download="tehranmu.apk">
                {props.language === 'en' ? 'Download' : 'دانلود'}
            </a>
            <img src={iconadnroid} alt='android'></img>
            </div>
        </div>
    )
}